module.exports = "<div>  \n  <template ngbModalContainer></template>\n  <router-outlet></router-outlet>\n  </div>"